<template>
  <div class="activity-wrap">
    <app-header />
    <div class="auto">
      <div class="slogan">
        <img src="@/assets/images/activity/activity202304/price-bg1.png" alt="">
        <span @click="goUrl()"></span>
      </div>
      <h2>
        <img src="@/assets/images/activity/activity202304/intro-bg.png" alt="" class="intro">
        <img src="@/assets/images/activity/activity202304/img1.png" alt="">
      </h2>
      <h3><strong>智能盯盘：</strong>多维度透视、智能测评手中个股</h3>
      <div class="mod">
        <p>基本面、技术面、资金面、消息面，四维一体智能诊断，全方位综合测评个股，轻松锁定高评分强势个股。</p>
        <img src="@/assets/images/activity/activity202304/img2.jpg" alt="">
      </div>
      <h5><img src="@/assets/images/activity/activity202304/buy-bg2.png" alt="" @click="goUrl()"></h5>
      <h3><strong>技术分析：</strong>全新决策链选股，技术面选股利器</h3>
      <div class="mod">
        <p>根据两市5000余只个股技术形态、指标共振、多周期强势、预计机会风险比做智能排序，筛选强势个股。</p>
        <img src="@/assets/images/activity/activity202304/img3.jpg" alt="">
      </div>
      <h3><strong>因子投研系统：</strong>定制属于自己的量化策略</h3>
      <div class="mod">
        <p>10000+投研因子自由组合，一分钟构建量化策略，提高选股效率，辅助决策思路。</p>
        <img src="@/assets/images/activity/activity202304/img4.jpg" alt="">
      </div>
      <h3><strong>大智慧产业链：</strong>快速捕捉热点方向，挖掘题材炒作机会</h3>
      <div class="mod">
        <p>一图展示各行业上下游关联，轻松查看行业核心公司，全面揭露行业重大信息。</p>
        <img src="@/assets/images/activity/activity202304/img5.jpg" alt="">
      </div>
      <h3><strong>研究员服务：</strong>全行业覆盖，线上实时答疑解惑</h3>
      <div class="mod">
        <p>定期输出机构监控报告（券商月度金股、券商策略周报、机构调研监控等）、直播路演，不定期邀请行情专家访谈，提供线上实时答疑服务。</p>
        <img src="@/assets/images/activity/activity202304/img6.jpg" alt="">
      </div>
    </div>
    <!-- <div class="footer-price"  @click="goUrl()">
      <img src="@/assets/images/activity/activity202304/price-bg2.png" alt="">
    </div> -->
  </div>
</template>
<script>
</script>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader,
  },
  data () {
    return {
      token: '',
      navIndex: 0
    }
  },
  created() {
    var token = this.$route.query.token;
    if (token) {
      this.token = token;
    }
  },
  mounted() {
    this.productClick()
  },
  methods: {
    // 335双周卡统计
    productClick () {
      var params =  {
        id : 335,
        num:  14,
        dateUnit: 'day',
        source: 'pc_baidu'
      }
      var userName = this.$storage.getUserName()
      if (!userName) return
      this.$post('/product/productClick', params)
        .then(res =>{
          // console.log(res)
        })
    },
    goUrl () {
      let routerDate = this.$router.resolve({name: 'OrderConfirm335', params:{month: '14d'}})
      let {href} = routerDate
      window.open(href, "_blank")
    }
  }
}
</script>

<style lang="scss" scoped>
div, p, span, a{
  box-sizing: border-box;
}
.activity-wrap{
  padding-bottom: 747px;
  background: url(../../assets/images/activity/activity202304/bg1.jpg) no-repeat center 100px,
              url(../../assets/images/activity/activity202304/bg2.jpg) no-repeat center 1100px,
              url(../../assets/images/activity/activity202304/bg3.jpg) no-repeat center 2100px,
              url(../../assets/images/activity/activity202304/bg4.jpg) no-repeat center 3100px,
              url(../../assets/images/activity/activity202304/bg5.jpg) no-repeat center 4100px,
              url(../../assets/images/activity/activity202304/bg6.jpg) no-repeat center 5100px,
              url(../../assets/images/activity/activity202304/bg7.jpg) no-repeat center 6100px,
              url(../../assets/images/activity/activity202304/bg8.jpg) no-repeat center 7073px #050672;
  img{
    display: block;
    margin: 0 auto;
  }
  .auto{
    width: 1200px;
    margin: 0px auto 0px;
  }
  .slogan{
    margin-top: 451px;
    margin-bottom: 245px;
    >img{
      margin: 0 auto 42px;
    }
    span{
      width: 574px;
      height: 86px;
      display: block;
      background: url(../../assets/images/activity/activity202304/buy-bg1.png) no-repeat;
      margin: 0 auto;
      cursor: pointer;
    }
  }
  h2{
    .intro{
      margin-bottom: 51px;
    }
  }
  h3{
    background: url(../../assets/images/activity/activity202304/title-bg.png) no-repeat 22px top;
    font-size: 40px;
    color: #fff;
    padding-left: 100px;
    height: 70px;
    line-height: 70px;
    margin: 98px 0 35px 0;
    strong{
      color: #50e2f8;
      font-weight: bold;
    }
  }
  .mod{
    background: #0b0cbc;
    padding: 46px 50px 60px;
    border-radius: 30px;
    position: relative;
    &:after{
      content: '';
      display: block;
      width: 146px;
      height: 28px;
      background: url(../../assets/images/activity/activity202304/mod-bg.png) no-repeat;
      position: absolute;
      right: 65px;
      bottom: 18px;
    }
    p{
      line-height: 60px;
      font-size: 28px;
      color: #fff;
      margin-bottom: 17px;
    }
  }
  h5{
    margin-top: 47px;
    img{
      cursor: pointer;
    }
  }
  .footer-price{
    position: fixed;
    left: 50%;
    margin-left: -498px;
    bottom: 60px;
    width: 996px;
    height: 173px;
    cursor: pointer;
  }
}

</style>


// WEBPACK FOOTER //
// src/pages/activity/activity202304.vue